import { NotificationType } from "./notificationTypes";

export const initialState: NotificationType = {
  fetching: false,
  error: null,
  message: "",
  success: null,
  statusCode: null,
  scheduleNotificationList: [],
  scheduleNotificationCount: 0,
  notificationCount: 0,
  scheduleNotificationListCount: 0,
  attendence: null,
};
